import React from 'react'
import { useAppDispatch } from '@core/Store/hooks'
import { setDisableTabNavigationRender } from '@core/Areas/Navigation/Store'

/** Only to be used on top level page routes - otherwise changes required */
export const useDisableTabNavigationRender = () => {
  const dispatch = useAppDispatch()

  React.useEffect(() => {
    dispatch(setDisableTabNavigationRender(true))
    return () => {
      dispatch(setDisableTabNavigationRender(false))
    }
  }, [dispatch])
}
